/**
 * Build stamp for the running SPA — what version/commit/time this bundle was built from.
 *
 * The `__*__` tokens are replaced at build time by Vite `define` (see vite.config.ts). The
 * `typeof` guards keep this safe in environments where they are NOT replaced (e.g. vitest),
 * where it falls back to dev placeholders instead of throwing a ReferenceError.
 *
 * The same data is also emitted as a static `/version.json` and an `<meta name="app-version">`.
 */
export interface BuildInfo {
  /** Semantic version of this release (from the git tag / package.json). */
  readonly version: string;
  /** Full commit SHA the bundle was built from, or `"unknown"`. */
  readonly commit: string;
  /** Git branch at build time, or `"unknown"`. */
  readonly branch: string;
  /** ISO-8601 UTC timestamp of the build. */
  readonly buildTime: string;
}

export const buildInfo: BuildInfo = {
  version: typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : '0.0.0-dev',
  commit: typeof __GIT_SHA__ !== 'undefined' ? __GIT_SHA__ : 'unknown',
  branch: typeof __GIT_BRANCH__ !== 'undefined' ? __GIT_BRANCH__ : 'unknown',
  buildTime: typeof __BUILD_TIME__ !== 'undefined' ? __BUILD_TIME__ : '',
};

/** Short commit for display (first 7 chars), or `"unknown"`. */
export const commitShort = buildInfo.commit === 'unknown' ? 'unknown' : buildInfo.commit.slice(0, 7);

/** `v0.1.0 · a1b2c3d` — compact one-line label for the UI. */
export const versionLabel = `v${buildInfo.version} · ${commitShort}`;
